/**
 * Top page only: vanilla JS smooth scroll.
 *
 * Lerps window.scrollY toward a wheel-driven target via requestAnimationFrame.
 * No transforms are applied to any element, so descendant `position: fixed`,
 * `position: sticky`, and `background-attachment: fixed` parallax CSS keep
 * working normally (unlike GSAP ScrollSmoother which transforms the content
 * wrapper and breaks fixed/sticky containing-block behavior).
 */
(function () {
  // TEMP: disable this feature without deleting code.
  var ENABLE_SCROLL_SMOOTHER_HOME = false;

  function init() {
    if (!document.body) return;
    if (!ENABLE_SCROLL_SMOOTHER_HOME) return;

    if (typeof window.matchMedia === 'function') {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;
    }

    /* smaller = smoother (slower catch-up) */
    var EASE = 0.08;
    var MIN_DELTA = 0.25;

    var targetY = window.scrollY || window.pageYOffset || 0;
    var currentY = targetY;
    var animating = false;
    var programmaticScroll = false;

    function maxY() {
      var doc = document.documentElement;
      return Math.max(0, (doc.scrollHeight || document.body.scrollHeight) - window.innerHeight);
    }

    function loop() {
      currentY += (targetY - currentY) * EASE;
      if (Math.abs(targetY - currentY) < MIN_DELTA) {
        currentY = targetY;
        programmaticScroll = true;
        window.scrollTo(0, currentY);
        animating = false;
        return;
      }
      programmaticScroll = true;
      window.scrollTo(0, currentY);
      if (animating) requestAnimationFrame(loop);
    }

    function hasInternalScrollableAncestor(el) {
      var node = el;
      while (node && node.nodeType === 1 && node !== document.body && node !== document.documentElement) {
        var style;
        try {
          style = window.getComputedStyle(node);
        } catch (_) {
          return false;
        }
        var oy = style.overflowY;
        if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay') && node.scrollHeight > node.clientHeight) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    }

    window.addEventListener(
      'wheel',
      function (e) {
        if (e.ctrlKey) return;
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
        if (e.target && hasInternalScrollableAncestor(e.target)) return;

        var delta = e.deltaY;
        if (e.deltaMode === 1) delta *= 16;
        else if (e.deltaMode === 2) delta *= window.innerHeight;

        e.preventDefault();
        targetY = Math.max(0, Math.min(maxY(), targetY + delta));
        if (!animating) {
          animating = true;
          requestAnimationFrame(loop);
        }
      },
      { passive: false }
    );

    window.addEventListener(
      'scroll',
      function () {
        if (programmaticScroll) {
          programmaticScroll = false;
          return;
        }
        if (!animating) {
          targetY = window.scrollY || window.pageYOffset || 0;
          currentY = targetY;
        }
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      targetY = Math.max(0, Math.min(maxY(), targetY));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
